require('./hireCardVirtualCreditError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');
const { catalogue, analyticsId } = require('../analytics/hireCardVirtualCreditAnalytics');

class HireCardVirtualCreditError extends React.Component {
    buildTexts() {
        const { immHireCardVirtualCredit, maxAllowedNumberCards, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_errorTitleGeneric';
        let textElement = (
            <FormattedText
                className="hire-card-virtual-credit-error__text"
                value="hireCardVirtualCredit-hireCardVirtualCredit_errorTextGeneric"
            />
        );

        if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }
        switch (immHireCardVirtualCredit.get('errorMsg')) {
            case 'requestInProgress':
                titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_errorTitlePending';
                textElement = (
                    <React.Fragment>
                        <div className="hire-card-virtual-credit-error__text hire-card-virtual-credit-error__text--margin-bottom">
                            <FormattedText
                                value="hireCardVirtualCredit-hireCardVirtualCredit_errorTextCallUs"
                            />
                        </div>
                        <div className="hire-card-virtual-credit-error__text">
                            <FormattedText
                                value="hireCardVirtualCredit-hireCardVirtualCredit_errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-virtual-credit-error__phone">
                            <i className="hire-card-virtual-credit-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardVirtualCredit-phoneNumberClients" />
                        </div>
                    </React.Fragment>
                );
                break;
            case 'maxAllowedNumberOfCardsExceeded':
                titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_errorTitleRejected';
                textElement = (
                    <div className="hire-card-virtual-credit-error--margin-top">
                        <div className="hire-card-virtual-credit-error__text">
                            <FormattedText
                                value="hireCardVirtualCredit-hireCardVirtualCredit_errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-virtual-credit-error__phone">
                            <i className="hire-card-virtual-credit-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardVirtualCredit-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case 'lowCreditScore':
                titleKey = 'hireCardVirtualCredit-hireCardVirtualCredit_errorTitleLowCreditScoreUpdated';
                textElement = (
                    <div>
                        <div className="hire-card-virtual-credit-error__text hire-card-virtual-credit-error__text--margin-bottom">
                            <FormattedText
                                value="hireCardVirtualCredit-hireCardVirtualCredit_lowCreditScoreMessage_updated"
                            />
                        </div>
                    </div>
                );
                break;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } : {
            label: (
                <FormattedText
                    value="hireCardVirtualCredit-hireCardVirtualCredit_errorBackButtonText"
                />
            ),
            url: '/myprofile/cards'
        };
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.VIRTUAL_CREDIT_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-virtual-credit-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardVirtualCreditError.propTypes = {
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardVirtualCreditError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = HireCardVirtualCreditError;
